export default __webpack_public_path__ + "static/media/chart-light.f637b571.png";